/**
 * Google translate breaks our app because of the way it manipulates the DOM. Its not necessarily a problem
 * with our code rather the way React works under the hood. For now both Google translate team and React hasn't decided
 * on a common solution. More can be found here: https://bugs.chromium.org/p/chromium/issues/detail?id=872770
 *
 * In the mean time React team suggests this work around to avoid crashing the app whenever user is using google translate
 * to use our application. Source: https://github.com/facebook/react/issues/11538#issuecomment-417504600
 *
 * @author Vishwajeet Srivastava <vishwajeet.srivastava@lastiminute.com>
 *
 */

export const loadGoogleTranslateWorkaround = initialize => {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild
    Node.prototype.removeChild = function(child) {
      if (child.parentNode !== this) {
        if (console && document.body.contains(child)) {
          console.error(
            'Cannot remove a child from a different parent',
            child,
            this
          )
        }
        return child
      }
      return originalRemoveChild.apply(this, arguments)
    }

    const originalInsertBefore = Node.prototype.insertBefore
    Node.prototype.insertBefore = function(newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        if (console) {
          console.error(
            'Cannot insert before a reference node from a different parent',
            referenceNode,
            this
          )
        }
        return newNode
      }
      return originalInsertBefore.apply(this, arguments)
    }
  }
  return initialize
}
